export const APP_NAME = 'Comercial digital';

export const BRAND_COLOR = '#135f9b';

export const API_URL = process.env.REACT_APP_API_URL as string;

export const ENVIROMENT = process.env.NODE_ENV;

export const DEFAULT_PUBLIC_PAGE = '/entrar';

export const DEFAULT_PRIVATE_PAGE = '/';

export const ACCESS_TOKEN_ID = '_react-leap_access';
export const REFRESH_TOKEN_ID = '_react-leap_refresh';
export const USER_INFO_ID = '_react-leap_user-info';

export const MSW_DB = '_react-leap_msw-db';

export const JWT_ACCESS_SECRET = '123456' as string;
export const JWT_ACCESS_EXPIRES_IN = 10;
export const JWT_REFRESH_SECRET = '123456789' as string;
export const JWT_REFRESH_EXPIRES_IN = 50;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT;
